<template>
  <div 
    class="frame-max" 
    :style="{left:(event_order-currentFrame)*width+'px'}">
      <slot></slot>
      <component
          :is="event_type"
          :for="For"
          :currentFrame="currentFrame"
          :event_order="event_order"
          :verify="verify"
          :goto="goto"
          :backto="backto"
          :form="form"
          :titleMap="titleMap"
          :frameNum="event_order"
          :showNext="showNext"
          :showBack="showBack"
          :showExit="showExit"
          :exitText="exitText"
          :exit="exit"
          :html_text="html_text"
          :src="video"
          :texts="texts"
          :timeout="timeout"
          :selection="selection"
          :fontsize="fontsize"
          :placeholder="placeholder"
          :maxLength="maxLength"
          :maxSelection="maxSelection"
          :minSelection="minSelection"
          @nextstep="nextstep"
          @backstep="backstep"
          @submit="submit"
          @exit="Exit"
      ></component>
  </div>
</template>


<script>

import VideoContext from '@/components/VideoContext.vue'
import TitleFrame from '@/components/TitleFrame.vue'
import CompletionPage from '@/components/CompletionPage.vue'
import ReviewFrame from '@/components/ReviewFrame.vue'
import ThankYouPage from '@/components/ThankYou.vue'
import TimeoutDisplay from '@/components/TimeoutDisplay'
import TextDisplay from '@/components/TextDisplay'
import TextInput from '@/components/TextInput'
import SelectionInput from '@/components/SelectionInput'
import CaptchaFrame from '@/components/CaptchaFrame'
import TextAreaInput from '@/components/TextAreaInput'

export default {
    name: "app-frame",
    components: {
        'video_player':VideoContext,
        'html_text': TitleFrame,
        'text_display':TextDisplay,
        'text_input':TextInput,
        'textarea_input':TextAreaInput,
        'select_input':SelectionInput,
        'timeout_display':TimeoutDisplay,
        'completion_page':CompletionPage,
        'review_page':ReviewFrame,
        'captcha_page':CaptchaFrame,
        'thank_you':ThankYouPage
    },
    props:{
      cards: {
        type: Array,
        default: function(){
          return []
        }
      },
      For:{
        type:String,
        default:"None"
      },
      goto:{
        type:Number,
      },
      backto:{
        type:Number,
      },
      exit:{
        type:Boolean,
        default:false
      },
      form:{
        type:Object,
        default: function(){
          return {} 
        }
      },
      titleMap:{
        type:Object,
        default: function(){
          return {}
        }
      },
      verify: {
        type: Array,
        default: function(){
          return []
        }
      },
      showNext:{
        type:Boolean,
        default:true
      },
      showBack:{
        type:Boolean,
        default:true
      },
      showExit:{
        type:Boolean,
        default:false
      },
      exitText:{
        type: String,
        default:"Exit"
      },
      color: {
        type: String,
        default: "#0044aa"
      },
      currentFrame:{
        type: Number,
        default: 1
      },
      event_order:{
        type: Number,
        default: 1
      },
      item: {
        type: Object
      },
      video: {
        type: String
      },
      event_type: {
        type: String
      },
      html_text: {
        type: String,
        default:""
      },
      texts: {
        type: Array,
          default: function(){
            return []
        }
      },
      timeout: {
        type:Number,
        default:3000
      },
      selection: {
        type: Array,
          default: function(){
            return []
        }
      },
      fontsize: {
        default:"1em",
        type:String
      },
      placeholder: {
        default:"James",
        type:String
      },
      maxLength: {
        default:"20",
        type:String
      },
      maxSelection: {
        default:1,
        type:Number
      },
      minSelection: {
        default:0,
        type:Number
      }
    },
    data: function(){
      return {
        width: window.innerWidth,
      }
    },
    methods: {
      Exit(){
        this.$emit('exit');
      },
      nextstep(event){
        //console.log(event)
        this.$emit('nextstep', event);
      },
      submit(){
        this.$emit('submit');
      },
      backstep(event){
        this.$emit('backstep', event);
      }
    }
}

</script>

<style scoped>

</style>
